import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './jsonEditor.css';
import { Button } from 'semantic-ui-react';

const EditorNode = React.memo(({ node, index, onEdit, onMove, onDelete, onRowClick, isSelected, isLast }) => {

  const handleMoveUp = () => {
    if (index > 0) {
      onMove({ startIndex: index, indexOfTarget: index - 1 });
    }
  };

  const handleMoveDown = () => {
    onMove({ startIndex: index, indexOfTarget: index + 1 });
  };

  const handleRowClick = () => {
    if (onRowClick) {
      onRowClick(node, index);
    }
  };

  // Returns the actual speaker name. Blank if the node has no speaker
  // (e.g. narration / book part / chapter rows).
  const getSpeaker = (node) => node.speaker || '';

  // Returns the category label derived from the node type. If node.type has been
  // replaced by a highlighted React node (during search), we just pass it through.
  const getCategoryFromType = (node) => {
    if (typeof node.type !== 'string') return node.type;
    switch (node.type) {
      case 'dialogue':
        return 'Dialogue';
      case 'narration':
        return 'Narration';
      case 'initialize':
        return 'Initializing';
      case 'bookPart':
        return 'Book Part';
      case 'chapter':
        return 'Chapter';
      default:
        return node.type;
    }
  };
  return (
    <div
      className={isLast ? "editor-node noBottomBorder" : "editor-node"}
      onClick={handleRowClick} // Added onClick handler to the outer div
      style={{ cursor: 'pointer' }} // Added pointer cursor to indicate it's clickable
    >

      <div className="field align-left">{getSpeaker(node)}</div>
      {/* <div className="field align-left">{node.uniqueKey}</div> */}
      <div className="field align-left">{getCategoryFromType(node)}</div>
      <div className="field align-left">{node.emotion ? node.emotion : "Neutral"}</div>
      <div className="field text-field align-left">{node.content === '\n' ? "No data..." : node.content}</div>

      {/* <div className="field align-left">{`${index + 1}:  ${node.key}`}</div>
      <div className="field align-left">{node.uniqueKey}</div>
      <div className="field align-left">{node.emotion}</div>
      <div className="field text-field align-left">{node.text === '\n' ? "No data..." : node.text}</div> */}
      <div className="actions">
        <Button
          basic
          type="button"
          icon="edit"
          onClick={(e) => { e.stopPropagation(); onEdit(index); }} // Prevents row click event when clicking the button
          className={`no-padding-border-button ${isSelected ? 'icon-button selected' : 'icon-button'}`}
        />
        <Button
          basic
          type="button"
          icon="arrow up"
          className="up-dwn-icon-button"
          onClick={(e) => { e.stopPropagation(); handleMoveUp(); }} // Prevents row click event
        />
        <Button
          basic
          type="button"
          icon="arrow down"
          className="up-dwn-icon-button"
          onClick={(e) => { e.stopPropagation(); handleMoveDown(); }} // Prevents row click event
        />
        <Button
          basic
          type="button"
          icon="trash"
          className="no-border-trash-button"
          onClick={(e) => { e.stopPropagation(); onDelete(index); }} // Prevents row click event
        />
      </div>
    </div>
  );
});

export default EditorNode;
